import { ImageUrl } from "../utils/ImageUrl";

export const CONSTANTS = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info",
};

export interface MasterVal {
  id: number | string;
  isChecked: boolean;
  isPrimary: boolean;
  isUnique: boolean;
  isForeign: boolean;
  isNull: boolean;
  isAuto: boolean;
  min: number | string;
  max: number | string;
  isExpression: boolean;
  isEnum: boolean;
  isQualityRule: boolean;
  isOnCard: boolean;
  masterValue: string | null;
  isFilled: boolean;
  masterType: string;
  label: string | null;
  type: string | null;
  length: number;
  default: string;
  subType?: string;
}

export const ADD_MASTER_TABLE: MasterVal[] = [
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: 5,
    max: 20,
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "name",
    isFilled: false,
    masterType: "string",
    label: "Name",
    type: "String",
    length: 10,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: 5,
    max: 10,
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "phoneNumber",
    isFilled: false,
    masterType: "Integer",
    label: "Phone Number",
    type: "Integer",
    length: 10,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: 5,
    max: 50,
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "email",
    isFilled: false,
    masterType: "string",
    label: "Email",
    type: "String",
    length: 50,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "id",
    isFilled: false,
    masterType: "integer",
    label: "ID",
    type: "integer",
    length: 10,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "address",
    isFilled: false,
    masterType: "string",
    label: "Address",
    type: "string",
    length: 100,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "description",
    isFilled: false,
    masterType: "string",
    label: "Description",
    type: "string",
    length: 100,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "title",
    isFilled: false,
    masterType: "string",
    label: "Title",
    type: "string",
    length: 50,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "subtitle",
    isFilled: false,
    masterType: "string",
    label: "Sub Title",
    type: "string",
    length: 50,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: "postalCode",
    isFilled: false,
    masterType: "integer",
    label: "Postal Code",
    type: "integer",
    length: 6,
    default: "",
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "date",
    label: 'Date',
    type: "date",
    length: 10,
    default: "",
    subType: 'date'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "datetime",
    label: 'Time',
    type: "datetime",
    length: 10,
    default: "",
    subType: 'time'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "datetime",
    label: 'Date Time',
    type: "datetime",
    length: 10,
    default: "",
    subType: 'timeStamp'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: 'number/quantity',
    isFilled: false,
    masterType: "",
    label: 'Number/Quantity',
    type: "integer",
    length: 10,
    default: "",
    subType: 'number/quantity'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: true,
    isUnique: true,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "",
    label: null,
    type: null,
    length: 10,
    default: "",
    subType: 'primary'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: true,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: false,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "",
    label: null,
    type: null,
    length: 10,
    default: "",
    subType: 'foreign'
  },
  {
    id: 0,
    isChecked: false,
    isPrimary: false,
    isUnique: false,
    isForeign: false,
    isNull: false,
    isAuto: false,
    min: "-",
    max: "-",
    isExpression: false,
    isEnum: true,
    isQualityRule: false,
    isOnCard: false,
    masterValue: '',
    isFilled: false,
    masterType: "",
    label: null,
    type: null,
    length: 10,
    default: "",
    subType: 'select'
  },
];

export const ALL_COLUMN_NAME = [
  {
    key: "1",
    header: "String",
    options: [
      { label: "Name", icon: ImageUrl.NameIcon, value: "name" },
      { label: "Email", icon: ImageUrl.EmailIcon, value: "email" },
      { label: "Phone Number", icon: ImageUrl.PhoneIcon, value: "phoneNumber" },
      { label: "Address", icon: ImageUrl.AddressIcon, value: "address" },
      { label: "Description", icon: ImageUrl.DescIcon, value: "description" },
      { label: "Title", icon: ImageUrl.TitleIcon, value: "title" },
      { label: "Subtitle", icon: ImageUrl.SubTitileIcon, value: "subtitle" },
    ],
  },
  {
    key: "2",
    header: "Numeric",
    options: [
      { label: "ID", icon: ImageUrl.IdIcon, value: "id" },
      {
        label: "Postal Code",
        icon: ImageUrl.PostalcodeIcon,
        value: "postalCode",
      },
      {
        label: "Number/Quantity",
        icon: ImageUrl.NumQuanIcon,
        value: "number/quantity",
      },
    ],
  },
  {
    key: "3",
    header: "Alpha-Numeric",
    options: [
      { label: "abc-234", icon: ImageUrl.A1Icon, value: "abc-234" },
      { label: "ab-538f@d", icon: ImageUrl.A1Icon, value: "ab-538f@d" },
    ],
  },
  {
    key: "4",
    header: "Derived",
    options: [
      { label: "Expression", icon: ImageUrl.A1Icon, value: "expression" },
    ],
  },
  {
    key: "5",
    header: "Keys",
    options: [
      { label: "Primary", icon: ImageUrl.A1Icon, value: "primary" },
      { label: "Foreign", icon: ImageUrl.A1Icon, value: "foreign" },
    ],
  },
  {
    key: "6",
    header: "Date/Time",
    options: [
      { label: "Date", icon: ImageUrl.A1Icon, value: "date" },
      { label: "Time", icon: ImageUrl.A1Icon, value: "time" },
      { label: "TimeStamp", icon: ImageUrl.A1Icon, value: "timeStamp" },
    ],
  },
  {
    key: "7",
    header: "Sensitive/Masked",
    options: [
      { label: "Password", icon: ImageUrl.A1Icon, value: "password" },
      { label: "Masked Field", icon: ImageUrl.A1Icon, value: "maskedField" },
    ],
  },
  {
    key: "8",
    header: "Blob",
    options: [
      {
        label: "Featured Image",
        icon: ImageUrl.A1Icon,
        value: "featuredImage",
      },
      { label: "File", icon: ImageUrl.A1Icon, value: "file" },
    ],
  },
  {
    key: "9",
    header: "Enum",
    options: [{ label: "Select", icon: ImageUrl.A1Icon, value: "select" }],
  },
];

export const DATA_TYPES = [
  { value: "integer", label: "Integer" },
  { value: "float", label: "Float" },
  { value: "double", label: "Double" },
  { value: "string", label: "String" },
  { value: "text", label: "Text" },
  { value: "boolean", label: "Boolean" },
  // { value: "selectable", label: "Selectable" },
  { value: "date", label: "Date" },
  { value: "datetime", label: "DateTime" },
  { value: "file", label: "File" },
];

export const ADD_TO_GROUPS_OPTION = [
  {
    label: "Basic Info",
    value: "basicInfo",
  },
  {
    label: "Address Info",
    value: "addressInfo",
  },
  {
    label: "Location Info",
    value: "locationInfo",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const SHOW_ON_CARD = [
  {
    label: "As Title",
    value: "asTitle",
  },
  {
    label: "As Subtitle",
    value: "asSubtitle",
  },
  {
    label: "As Caption Text",
    value: "asCaptionText",
  },
  {
    label: "Featured Image",
    value: "featuredImage",
  },
];
